import styled from 'styled-components';
import { animated } from 'react-spring';

export const Container = styled(animated.div)`
  display: flex;
  flex-direction: column;
  z-index: 9;
  width: 100%;

  > h3 {
    font-size: 1.4rem;
    color: #610082;
    text-transform: capitalize;
    margin-bottom: 22px;
  }

  position: relative;
`;

export const Select = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 40px;
  border-radius: 20px;
  border: 0;
  background: ${(props) => (props.background ? props.background : 'red')};
  color: #6c6c6c;
  padding: 0 20px;
  font-size: 1.4rem;
  cursor: pointer;
  transition: border-radius 0.2s linear;

  .label {
    white-space: nowrap;
    max-width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &.borderTop {
    border-radius: 20px 20px 0 0;
  }

  &.borderBottom {
    border-radius: 10px;
  }

  .active:first-of-type {
    transform: rotate(-180deg);
    transition: 0.2s linear;
  }

  .noActive {
    transform: rotate(0deg);
    transition: 0.2s linear;
  }
`;

export const FieldGroup = styled(animated.div)`
  background-color: ${(props) => (props.background ? props.background : '#F5F6FA')};
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.05);
  border-radius: 20px;
  padding: 0 20px;
  top: ${(props) => (props.title ? '79px' : '40px')};
  left: 0px;
  width: 100%;
  position: absolute;
  transition: border-radius 0.2s linear;

  &.borderTop {
    border-radius: 0 0 10px 10px;
    max-height: 360px;
    overflow: auto;
  }

  &.borderBottom {
    border-radius: 0px;
  }
`;

export const Field = styled.div`
  padding: 10px 0;

  input {
    margin-bottom: 20px;
  }

  label {
    font-size: 1.4rem;
    color: #6c6c6c;
    margin-left: 18px;
  }
`;
